<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635.999 290.231" class="w-full h-auto">
    <g id="illustration_frontdesk" transform="translate(0 0)">
      <g id="Group_1421" data-name="Group 1421" transform="translate(0 23.317)">
        <path
          id="Path_4831"
          data-name="Path 4831"
          d="M24.979,267.14c1.673.016,3.331.016,5,.031h0q14,.1,28.01.194,12.723.07,25.438.163,27.4.186,54.78.364,8.3.07,16.6.116,26.956.186,53.913.364,21.507.139,43.014.287,14.431.093,28.854.194,11.468.07,22.928.155l53.9.372q14.8.093,29.613.194l54.393.372q21.879.151,43.773.294,14.048.093,28.1.186,11.224.07,22.448.155l54.378.372c2.928.016,5.872.039,8.8.054q2.7-3.683,5.221-7.444c33.633-50.35,41.527-110.429,19.357-157.541A132.173,132.173,0,0,0,604.89,77.15a139.277,139.277,0,0,0-21.666-20.674,129.359,129.359,0,0,0-46.523-22.9c-3.2-.813-6.414-1.487-9.667-2.022a106.441,106.441,0,0,0-21.472-1.379A117.373,117.373,0,0,0,464.43,39.7a204.151,204.151,0,0,0-29.908,15.9c-16.081,10.132-31.41,21.867-46.755,32.379-11.712,8.025-23.44,15.345-35.516,20.7-15.244,6.778-31.054,10.419-48.119,8.428a84.019,84.019,0,0,1-11.224-2.1,69.238,69.238,0,0,1-17.491-6.964c-16.491-9.466-23.959-23.943-41.589-38.157a129.506,129.506,0,0,0-32.1-18.715c-1.325-.55-2.672-1.092-4.067-1.642a237.773,237.773,0,0,0-41.93-11.79A208.882,208.882,0,0,0,130.7,34.593c-14.88-.953-30.837-.194-46.353,3.757A104.7,104.7,0,0,0,51.1,53.083a96.828,96.828,0,0,0-9.528,7.367A111.778,111.778,0,0,0,14.638,96.888C-6.935,142.35-5.618,207.03,24.979,267.147Z"
          transform="translate(0.001 -30.103)"
          fill="#00a1aa"
          opacity="0.07"
          style="mix-blend-mode: normal; isolation: isolate"
        />
        <g id="Group_1420" data-name="Group 1420" transform="translate(14.631 0.137)" opacity="0.32">
          <path
            id="Path_4832"
            data-name="Path 4832"
            d="M59.21,271.652q27.189.186,54.378.364l-6.91-214.459a129.36,129.36,0,0,0-46.523-22.9L59.21,271.652Z"
            transform="translate(461.916 -31.267)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4833"
            data-name="Path 4833"
            d="M0,277.313C33.641,226.978,41.534,166.892,19.365,119.78A132.172,132.172,0,0,0,.744,90.91Z"
            transform="translate(589.516 -43.945)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4834"
            data-name="Path 4834"
            d="M251.18,277.061q27.189.186,54.393.364L298.664,63.09c-16.081,10.14-31.41,21.867-46.755,32.379l-.728,181.584Z"
            transform="translate(121.229 -37.675)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4835"
            data-name="Path 4835"
            d="M158.4,39.8l20.767,230.532q14.048.093,28.1.186L199.532,30.28A117.033,117.033,0,0,0,158.4,39.8Z"
            transform="translate(291.4 -30.28)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4836"
            data-name="Path 4836"
            d="M359.63,291.947l53.9.364-5.182-160.7c-15.244,6.778-31.054,10.426-48.119,8.428Z"
            transform="translate(-70.74 -53.119)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4837"
            data-name="Path 4837"
            d="M551.6,270.317q26.956.186,53.913.356l-7-217.2c-1.324-.55-2.672-1.1-4.067-1.642a238.5,238.5,0,0,0-41.93-11.79Z"
            transform="translate(-411.419 -32.48)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4838"
            data-name="Path 4838"
            d="M642.63,268.8q27.4.186,54.78.364L689.889,35.862c-14.88-.953-30.837-.194-46.353,3.757L642.63,268.8Z"
            transform="translate(-573.829 -31.455)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4839"
            data-name="Path 4839"
            d="M458.81,81.54l17.917,198.781q14.431.093,28.854.194L500.4,119.705C483.907,110.239,476.44,95.762,458.81,81.54Z"
            transform="translate(-239.611 -41.833)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4840"
            data-name="Path 4840"
            d="M746.2,103.644l15.345,170.291h0q14,.093,28.01.194l-6.9-214.289a96.823,96.823,0,0,0-9.528,7.367,111.808,111.808,0,0,0-26.933,36.445Z"
            transform="translate(-746.19 -36.942)"
            fill="#00a1aa"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          />
        </g>
      </g>
      <g id="Group_1430" data-name="Group 1430" transform="translate(12.617 0)">
        <g id="Group_1424" data-name="Group 1424" transform="translate(283.809 0)">
          <g id="Group_1422" data-name="Group 1422" transform="translate(7.89 103.441)">
            <path
              id="Path_4841"
              data-name="Path 4841"
              d="M408.035,133.54s15.415,41.109-4.222,73.968c-21.658,7.157-31.751,3.486-32.115,2.572s-14.679-37.809-2.572-74.7c30.651-.914,38.909-1.836,38.909-1.836Z"
              transform="translate(-364.273 -133.54)"
              fill="#017575"
            />
            <path
              id="Path_4842"
              data-name="Path 4842"
              d="M389.427,207.51c-9.992,3.3-17.491,4.284-22.743,4.315-.8-.271-1.58-.535-2.4-.829,37.259-36.523,21.286-75.246,21.286-75.246l5.507-1.983c1.828-.139,2.564-.217,2.564-.217s15.415,41.109-4.222,73.968Z"
              transform="translate(-349.887 -133.542)"
              fill="#017575"
            />
          </g>
          <g id="Group_1423" data-name="Group 1423" transform="translate(0 46.272)">
            <path
              id="Path_4843"
              data-name="Path 4843"
              d="M432.4,63.817s-4.958-1.65-8.536,4.129-12.084,22.348-12.007,28.2c.116,8.389,12.464,22.185,12.464,22.185l8.079-3.486s-10.69-15.144-10.968-17.2,7.018-8.854,8.3-14.082S432.4,63.824,432.4,63.824Z"
              transform="translate(-411.86 -60.607)"
              fill="#00a1aa"
            />
            <path
              id="Path_4844"
              data-name="Path 4844"
              d="M413.629,118.561s-16.654,10.047-43.773,3.858c2.2-6.2,11.425-19.412,11.565-22.572s-11.425-9.5-10.047-18.722,3.718-17.072,7.018-18.722,20.783-3.734,31.519,3.091c6.336,4.206-2.339,28.707-7.707,36.143,7.568,6.607,11.565,12.115,11.425,16.933Z"
              transform="translate(-360.552 -59.967)"
              fill="#00a1aa"
            />
            <path
              id="Path_4845"
              data-name="Path 4845"
              d="M413.619,125.526s-16.654,10.047-43.773,3.858c2.2-6.2,11.425-19.412,11.565-22.572.116-2.742-8.505-7.855-9.946-15.151a10.848,10.848,0,0,0,2.688.937,77.87,77.87,0,0,0,21.635,1.975,22.56,22.56,0,0,1,5.314.1,6.4,6.4,0,0,1,4.384,2.742,8.725,8.725,0,0,1,.953,3.269,45.5,45.5,0,0,1-4.237,7.924c7.568,6.607,11.565,12.115,11.426,16.933Z"
              transform="translate(-360.542 -66.932)"
              fill="#00a1aa"
            />
            <path
              id="Path_4846"
              data-name="Path 4846"
              d="M318.248,65.473c-2.518-.829-5.709.186-5.887,9.357s4.957,48.111,54.2,52.162c1.689-4.671.7-5.724.7-5.724s-36.91-10.186-40.349-34.687a73.9,73.9,0,0,1-1.4-11.333c-.6-8.219-4.733-8.947-7.25-9.776Z"
              transform="translate(-269.928 -60.977)"
              fill="#00a1aa"
            />
            <path
              id="Path_4847"
              data-name="Path 4847"
              d="M404.235,62.032s-8.164,12.758-14.958,14.679-7.707-16.189-7.707-16.189,12.022-2.533,22.665,1.5Z"
              transform="translate(-360.229 -59.737)"
              fill="#f0e2e4"
            />
            <path
              id="Path_4848"
              data-name="Path 4848"
              d="M291.855,141.485s8.265,6.081,15.066,2.928c4.152-2.1,1.882-6.917-.612-7.134s-4.872.937-5.2.387,1.387-1.053,1.387-1.937-2.432-1.053-3.486-.666-5.848,2.913-6.476,3.261c-.682.387-.682,3.153-.682,3.153Z"
              transform="translate(-195.718 -76.67)"
              fill="#f8a17a"
            />
          </g>
          <path
            id="Path_4849"
            data-name="Path 4849"
            d="M388.535,58.11a79.4,79.4,0,0,0-2.215-13.571,43.409,43.409,0,0,1,14.384-5.3l-.96,15.144-7.808,4.408-3.393-.674Z"
            transform="translate(-360.378 -8.845)"
            fill="#f8a17a"
          />
          <path
            id="Path_4850"
            data-name="Path 4850"
            d="M394.518,54.64l.488,6.793-7.336,6.7-1.751-5.872Z"
            transform="translate(-354.37 -12.316)"
            fill="#96b6cc"
          />
          <path
            id="Path_4851"
            data-name="Path 4851"
            d="M398.926,67.129l5.507-4.865-5.507-7.614s-1.286,3.943-1.286,4.222S398.926,67.129,398.926,67.129Z"
            transform="translate(-372.875 -12.318)"
            fill="#96b6cc"
          />
          <path
            id="Path_4852"
            data-name="Path 4852"
            d="M407.058,21.637a40.873,40.873,0,0,0,.372-9.528,9.114,9.114,0,0,0-1.642-4.353c-1.952-2.587-4.609-2.479-7.475-2.812-1.7-.2-7.909-4.02-13.6-2.587a15.248,15.248,0,0,0-9,6.762,11.315,11.315,0,0,0-1.929,6.569,7.83,7.83,0,0,0,3.447,5.833,6.969,6.969,0,0,0,7.173.077,19.008,19.008,0,0,0,5.1-4.384,44.889,44.889,0,0,1,3.23-3.416c.744-.674,2.417-2.6,3.571-1.952,1.983,1.108,1.356,4.872,1.247,6.677a53.477,53.477,0,0,1-1.7,10.45c-.294,1.1-.612,11.395,7.87,6.158,6.027-3.718,2.858-8.745,3.346-13.478Z"
            transform="translate(-357.544 -0.46)"
            fill="#212121"
          />
          <path
            id="Path_4853"
            data-name="Path 4853"
            d="M384.893,13.175c-.263.248-4.129,8.885-3.122,14.811s2.479,14.78,12.161,14.733c6.2-.031,14.361-7.9,13.718-19.83S396.457,2.315,384.893,13.175Z"
            transform="translate(-363.706 -1.851)"
            fill="#f8a17a"
          />
          <path
            id="Path_4854"
            data-name="Path 4854"
            d="M406.476,34.618s6.948-13.285,3.648-15.833-7.5-2-7.777-5.507.55-3.579.55-3.579-3.858,0-5.3,2.339c-1.673,2.711-7.552,10.62-14.175,7.986s-9.535-14.818-1.332-12.982S391.937-2.912,402.123.69s10.349,13.556,9.59,15.624,2.9,8.257.418,11.356-5.647,6.948-5.647,6.948Z"
            transform="translate(-365.53 -0.001)"
            fill="#212121"
          />
        </g>
        <g id="Artwork_16" data-name="Artwork 16" transform="translate(516.181 191.184)">
          <path
            id="Path_4855"
            data-name="Path 4855"
            d="M134.338,247.942a120.6,120.6,0,0,0-8.536,15.3c-2.363,5.229-4.067,11.023-3.067,16.786.163.961-1.3,1.371-1.472.4-1.007-5.856.48-11.619,2.8-16.987a114.65,114.65,0,0,1,8.962-16.275c.527-.821,1.844-.062,1.317.767h0Z"
            transform="translate(-120.942 -246.814)"
            fill="#b4bded"
          />
        </g>
        <g id="Group_1425" data-name="Group 1425" transform="translate(174.155 61.279)">
          <rect
            id="Rectangle_697"
            data-name="Rectangle 697"
            width="70.257"
            height="46.469"
            rx="2.88"
            transform="translate(1.177)"
            fill="#fff"
          />
          <rect
            id="Rectangle_698"
            data-name="Rectangle 698"
            width="70.257"
            height="46.469"
            rx="2.88"
            transform="translate(0)"
            fill="#708999"
          />
          <path
            id="Path_4856"
            data-name="Path 4856"
            d="M536.464,122.78h-.372a8.865,8.865,0,0,0-8.862,8.862v23.107h18.095V131.642A8.865,8.865,0,0,0,536.464,122.78Z"
            transform="translate(-504.495 -88.953)"
            fill="#2a2a7c"
          />
          <path
            id="Path_4857"
            data-name="Path 4857"
            d="M538.463,122.78h-.372a8.865,8.865,0,0,0-8.861,8.862v23.107h18.095V131.642A8.865,8.865,0,0,0,538.463,122.78Z"
            transform="translate(-508.044 -88.953)"
            fill="#708999"
          />
          <rect
            id="Rectangle_699"
            data-name="Rectangle 699"
            width="13.261"
            height="2.316"
            transform="translate(44.354 65.803)"
            fill="#7a79cc"
          />
          <rect
            id="Rectangle_700"
            data-name="Rectangle 700"
            width="30.605"
            height="2.316"
            transform="translate(13.757 65.803)"
            fill="#9595ce"
          />
        </g>
        <g id="Group_1426" data-name="Group 1426" transform="translate(0 124.27)">
          <path
            id="Path_4858"
            data-name="Path 4858"
            d="M643.756,177.193H227.915L223.5,160.43H643.756Z"
            transform="translate(-193.499 -160.43)"
            fill="#00a1aa"
          />
          <path
            id="Path_4859"
            data-name="Path 4859"
            d="M623.779,304.73H246.986L223.5,182.07H623.779Z"
            transform="translate(-173.522 -165.307)"
            opacity="0.91"
            style="mix-blend-mode: normal; isolation: isolate"
          />
          <path
            id="Path_4860"
            data-name="Path 4860"
            d="M583.52,307.3H126.315L112.86,193.47H583.52Z"
            transform="translate(-47.56 -167.877)"
            fill="#046060"
          />
          <path
            id="Path_4861"
            data-name="Path 4861"
            d="M735.3,299.852h48.1L756.7,160.43H709.93Z"
            transform="translate(-709.93 -160.43)"
            fill="#00a1aa"
          />
          <path
            id="Path_4862"
            data-name="Path 4862"
            d="M57.47,307.3h48.088L143.281,193.47H94.264Z"
            transform="translate(435.584 -167.877)"
            fill="#00a1aa"
          />
          <rect
            id="Rectangle_701"
            data-name="Rectangle 701"
            width="376.793"
            height="16.763"
            transform="translate(164.349 25.593)"
            fill="#00a1aa"
          />
          <rect
            id="Rectangle_702"
            data-name="Rectangle 702"
            width="202.46"
            height="4.934"
            transform="translate(55.052 62.891)"
            fill="#00a1aa"
          />
          <rect
            id="Rectangle_703"
            data-name="Rectangle 703"
            width="202.46"
            height="4.934"
            transform="translate(48.467 72.837)"
            fill="#00a1aa"
          />
          <rect
            id="Rectangle_704"
            data-name="Rectangle 704"
            width="199.516"
            height="4.934"
            transform="translate(44.819 82.783)"
            fill="#00a1aa"
          />
          <rect
            id="Rectangle_705"
            data-name="Rectangle 705"
            width="195.875"
            height="4.934"
            transform="translate(41.875 92.721)"
            fill="#00a1aa"
          />
          <rect
            id="Rectangle_706"
            data-name="Rectangle 706"
            width="186.348"
            height="4.934"
            transform="translate(44.819 102.667)"
            fill="#00a1aa"
          />
          <rect
            id="Rectangle_707"
            data-name="Rectangle 707"
            width="179.764"
            height="4.934"
            transform="translate(44.819 112.613)"
            fill="#00a1aa"
          />
        </g>
        <path
          id="Path_4863"
          data-name="Path 4863"
          d="M458.376,307.3l29.668-92.039H127.75V193.47h8.071v16.763H495.9L464.527,307.3Z"
          transform="translate(28.527 -43.607)"
          opacity="0.91"
          style="mix-blend-mode: normal; isolation: isolate"
        />
        <g id="Group_1429" data-name="Group 1429" transform="translate(100.41 2.975)">
          <ellipse
            id="Ellipse_176"
            data-name="Ellipse 176"
            cx="57.476"
            cy="5.391"
            rx="57.476"
            ry="5.391"
            transform="translate(9.461 276.473)"
            fill="#3f5e8c"
          />
          <g id="Group_1427" data-name="Group 1427" transform="translate(18.826 167.431)">
            <path
              id="Path_4864"
              data-name="Path 4864"
              d="M596.595,326.608l-10.744-.852s-14.33-28.661-15.012-49.815c-6.313-13.478-13.819-47.081-13.819-47.081l18.505-8.869s5.391,44.556,8.118,55.981,9.195,34.091,12.951,50.636Z"
              transform="translate(-523.921 -219.99)"
              fill="#5b1636"
            />
            <path
              id="Path_4865"
              data-name="Path 4865"
              d="M641.76,230.093l2.727,97.407h-6.654s-8.869-44.354-10.4-54.246,2.045-24.563,0-28.661-4.779-20.643-4.779-20.643Z"
              transform="translate(-622.65 -220.883)"
              fill="#5b1636"
            />
            <path
              id="Path_4866"
              data-name="Path 4866"
              d="M565.1,362.084s-25.872,1.6-26.468.821-1.278-10.829,1.448-12.8,9.125-.937,9.125-.937,8.7,8.443,11.689,8.358,6.878,2.959,4.206,4.547Z"
              transform="translate(-478.666 -249.045)"
              fill="#212121"
            />
            <path
              id="Path_4867"
              data-name="Path 4867"
              d="M632.374,360.034s3.238,2.378-1.619,2.851-19.109.728-11.433-3.966a21.9,21.9,0,0,1-1.108-5.8c-.341-3.927,3.408-5.035,4.183-5.205s9.125.341,9.3,2.812-.426,7.165.426,7.165.256,2.13.256,2.13Z"
              transform="translate(-607.292 -248.815)"
              fill="#212121"
            />
          </g>
          <path
            id="Path_4868"
            data-name="Path 4868"
            d="M657.892,185.073c-2.06-.077-7.026-2.727-7.026-2.727s3.153-27,4.47-39.947c.9-8.792,12.727-5.058,10.519,6.631-1.425,7.529-5.9,36.112-7.963,36.035Z"
            transform="translate(-647.324 -33.978)"
            fill="#3f5e8c"
          />
          <path
            id="Path_4869"
            data-name="Path 4869"
            d="M640.933,187.947s-17.057,23.54-62.774,5.461c-3.757-1.022,6.824-74.037,3.408-88.368S565.6,73.312,577.337,67.851s38.692.682,41.759,6.143c3.067,7.506,4.438,54.928,8.869,70.621s12.967,43.332,12.967,43.332Z"
            transform="translate(-561.37 -17.789)"
            fill="#3f5e8c"
          />
          <path
            id="Path_4870"
            data-name="Path 4870"
            d="M578.413,85.269c.5-3.215,1.89-6.584,4.779-8.079a14.684,14.684,0,0,1,5.244-1.239,3.13,3.13,0,0,1,.24.349c3.068,7.506,4.439,54.928,8.869,70.621,2.332,8.25,5.794,19.791,8.552,28.893-.465-.085-.937-.139-1.4-.248a11.427,11.427,0,0,1-5.709-2.727c-1.727-1.743-2.4-4.245-3.013-6.623q-1.522-5.926-3.036-11.859a12.048,12.048,0,0,0,4.315-1.022q-5.984-22.146-14-43.673c-2.928-7.862-6.112-16.112-4.834-24.4Z"
            transform="translate(-530.95 -20.094)"
            fill="#37506d"
          />
          <path
            id="Path_4871"
            data-name="Path 4871"
            d="M543.57,166.08s8.862,3.819,9.28,6.724-6.553,10.372-9.04,9.543-6.166-4.47-5.755-5.484-.078-6.894-.078-6.894l4.779-3.881h.813Z"
            transform="translate(-446.617 -40.408)"
            fill="#d69d69"
          />
          <path
            id="Path_4872"
            data-name="Path 4872"
            d="M588.39,150.719s-14.183-12.843-23.509-22.526c-8.5-8.823-15.206-38.762-15.206-38.762s-.511-20.419,7.057-14.733,14.214,40.148,14.214,40.148,23.533,24.966,25.763,27.994-5.546,9.388-8.319,7.87Z"
            transform="translate(-499.911 -19.587)"
            fill="#3f5e8c"
          />
          <g id="Group_1428" data-name="Group 1428" transform="translate(7.051 50.866)">
            <path
              id="Path_4873"
              data-name="Path 4873"
              d="M645.108,127.629c.573-8.776-5.143-52.232,6.228-57.894,5.717-2.851,9.776,22.154,9.776,22.154s-4.865,32.813-5.562,41.1-11.007,3.408-10.434-5.368Z"
              transform="translate(-644.17 -69.508)"
              fill="#3f5e8c"
            />
            <path
              id="Path_4874"
              data-name="Path 4874"
              d="M649.735,106.736,646.66,102.7s.8,13.362.836,19.458c.976-.883,2.239-15.423,2.239-15.423Z"
              transform="translate(-634.723 -76.989)"
              fill="#3f5e8c"
            />
          </g>
          <ellipse
            id="Ellipse_177"
            data-name="Ellipse 177"
            cx="13.192"
            cy="18.823"
            rx="13.192"
            ry="18.823"
            transform="translate(23.985 5.251)"
            fill="#d69d69"
          />
          <path
            id="Path_4875"
            data-name="Path 4875"
            d="M624.64,51.773c0,.341-5.12,13.873-5.12,13.873l16.832,2.8s-1.7-12.13-.682-16.112S624.64,51.773,624.64,51.773Z"
            transform="translate(-593.266 -14.338)"
            fill="#d69d69"
          />
          <path
            id="Path_4876"
            data-name="Path 4876"
            d="M639.882,62.609s-19.388-.457-21.325-3.524-2.386,10.008-2.386,10.008,21.038,2.618,22.975,2.161.744-8.645.744-8.645Z"
            transform="translate(-594.572 -16.188)"
            fill="#37506d"
          />
          <path
            id="Path_4877"
            data-name="Path 4877"
            d="M652.96,32.067s-21.379,20.31-50.04,7.855c0,0,14.33-19.621,15.694-29s23.85-9.381,28.165-.341,6.181,21.5,6.181,21.5Z"
            transform="translate(-597.015 -3.842)"
            fill="#212121"
          />
          <path
            id="Path_4878"
            data-name="Path 4878"
            d="M640.561,70.632S619.453,153,607.788,173.834c-1.077-2.587-.442-1.944-.442-1.944s31.1-96.261,30.938-102.04c1.929.349,2.285.775,2.285.775Z"
            transform="translate(-587.908 -18.719)"
            fill="#723f3b"
          />
          <path
            id="Path_4879"
            data-name="Path 4879"
            d="M665.2,196.509c-3.354-.349-9.442.48-10.666,3.989-1.154,3.323-5.066,16.453-2.285,16.507,3.184-.72,10.736,3.966,12.084.3,1.356-4.446,5.577-14.787,5.422-19.435-.039-1.255-1.875-1.263-4.555-1.371Z"
            transform="translate(-651.275 -47.25)"
            fill="#723f3b"
          />
          <path
            id="Path_4880"
            data-name="Path 4880"
            d="M656.155,204.1c-2.223-17.1-7.893,8.428-7.405,13.625C655.512,219.132,654.312,208.574,656.155,204.1Z"
            transform="translate(-635.687 -47.665)"
            fill="#c68166"
          />
        </g>
      </g>
      <g id="Group_1431" data-name="Group 1431" transform="translate(531.943 74.192)">
        <path
          id="Path_4881"
          data-name="Path 4881"
          d="M110.358,143.123l-8.548-5.5a28.208,28.208,0,0,1-4.6-10.953,28.977,28.977,0,0,1-.343-3.129l3.606.076-3.587-3.492a41.009,41.009,0,0,1,1.717-9.2A41.932,41.932,0,0,1,103.7,99.771a110.925,110.925,0,0,1,10.952,10.437c.115.134.229.249.344.382l-.458,4.961,2.022-3.149a40.26,40.26,0,0,1,8.223,14.406,28.6,28.6,0,0,1,.764,3.492l-3.721,7.728,4.064-1.851c-.229,6.6-2.366,13.108-5.19,19.138-3.587-2.156-12.04-9.673-14.272-12-.744-.763-1.45-1.565-2.137-2.385l6.068,2.194Z"
          transform="translate(-96.868 -96.68)"
          fill="#00a1aa"
        />
        <line
          id="Line_314"
          data-name="Line 314"
          x1="12.326"
          y1="39.555"
          transform="translate(11.429 19.157)"
          fill="none"
          stroke="#fff"
          stroke-width="1"
          opacity="0.36"
          style="mix-blend-mode: normal; isolation: isolate"
        />
        <path
          id="Path_4882"
          data-name="Path 4882"
          d="M88.022,138.674l-6.068-8.147a28.321,28.321,0,0,1-.439-11.869,24.062,24.062,0,0,1,.782-3.053l3.359,1.335-2.119-4.522A44.451,44.451,0,0,1,97.086,95.781a109.006,109.006,0,0,1,6.563,13.624,4.886,4.886,0,0,0,.191.476l-2.175,4.484,3-2.232c1.851,5.285,3.072,10.819,2.614,16.371a26.659,26.659,0,0,1-.515,3.53l-6.2,5.915,4.445-.305c-2.538,6.087-6.85,11.429-11.6,16.086-2.595-3.282-7.862-13.3-9.121-16.258-.42-.973-.8-1.984-1.163-3l4.9,4.2Z"
          transform="translate(-66.118 -95.781)"
          fill="#5cc2c9"
        />
        <line
          id="Line_315"
          data-name="Line 315"
          y1="41.367"
          x2="2.423"
          transform="translate(27.171 16.638)"
          fill="none"
          stroke="#fff"
          stroke-width="1"
          opacity="0.36"
          style="mix-blend-mode: normal; isolation: isolate"
        />
        <path
          id="Path_4883"
          data-name="Path 4883"
          d="M80.018,147.142l7.04-4.522a21.69,21.69,0,0,0,4.084-11.6l-2.977.057,2.957-2.881a34.212,34.212,0,0,0-1.412-7.575,34.575,34.575,0,0,0-4.2-9.2,91.372,91.372,0,0,0-9.025,8.605c-.1.1-.191.21-.287.325l.363,4.083-1.66-2.595a32.948,32.948,0,0,0-6.774,11.869,25.145,25.145,0,0,0-.63,2.881l3.072,6.373-3.339-1.527A41.4,41.4,0,0,0,71.508,157.2c2.957-1.775,9.922-7.976,11.773-9.884.61-.63,1.2-1.3,1.755-1.965l-5.018,1.793Z"
          transform="translate(-39.166 -99.307)"
          fill="#00a1aa"
        />
        <line
          id="Line_316"
          data-name="Line 316"
          y1="32.609"
          x2="10.151"
          transform="translate(32.399 25.339)"
          fill="none"
          stroke="#fff"
          stroke-width="1"
          opacity="0.36"
          style="mix-blend-mode: normal; isolation: isolate"
        />
        <path
          id="Path_4884"
          data-name="Path 4884"
          d="M83.369,162.683,85.678,186.4H104.8l2.29-23.718Z"
          transform="translate(-67.608 -110.86)"
          fill="#141449"
        />
        <path
          id="Path_4885"
          data-name="Path 4885"
          d="M91.005,162.683,93.314,186.4H106.5l2.309-23.718Z"
          transform="translate(-75.245 -110.86)"
          fill="#267476"
        />
        <path
          id="Path_4886"
          data-name="Path 4886"
          d="M83.369,186.4H89.3l2.29-23.718H85.678Z"
          transform="translate(-52.115 -110.86)"
          opacity="0.91"
          style="mix-blend-mode: normal; isolation: isolate"
        />
      </g>
    </g>
  </svg>
</template>
